import eventManagerUtil from './event-manager-util';
import langMap from '../constants/lang-map';
import config from '../constants/config';
const getBrowserLang=()=>{
    const browserLang=(navigator.language||navigator.userLanguage).split('-')[0];
    if(Object.keys(langMap).includes(browserLang)){
        return browserLang;
    }
    return 'en';
};
let globalSettings={
    lang:localStorage.getItem('lang')||getBrowserLang(),
    token:localStorage.getItem('token'),
};
const infer=async(force)=>{
    if(force===undefined){
        force=false;
    }
    if(!globalSettings.token){
        globalSettings.user=null;
    }
    else if(!globalSettings.user||force){
        const res=await fetch(`${config.API_URL}/get-user`,{
            method:'GET',
            headers:{
                'Authorization':`Bearer ${globalSettings.token}`,
            },
        });
        if(res.status!==200){
            updateGlobalSettings({
                token:null,
            });
            window.location.href='/login';
            return;
        }
        globalSettings.user=await res.json();
    }
    eventManagerUtil.emitAll('update-global-settings',globalSettings);
};
infer();
const getGlobalSettings=()=>{
    return globalSettings;
};
const setItem=(k,v)=>{
    if(v){
        localStorage.setItem(k,v);
    }
    else{
        localStorage.removeItem(k);
    }
};
const updateGlobalSettings=(changes)=>{
    globalSettings=Object.assign(globalSettings,changes);
    setItem('lang',globalSettings.lang);
    setItem('token',globalSettings.token);
    eventManagerUtil.emitAll('update-global-settings',globalSettings);
    infer();
};
export default {
    getGlobalSettings,
    updateGlobalSettings,
    infer,
};

